(function ($) {
  saLinkV1 = {
    formatter: $('.sa-link-v1')
  };

  Drupal.behaviors.saLinkV1 = {
    get: function (key) {
      return saLinkV1[key];
    },

    set: function (key, val) {
      saLinkV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.once('sa-link-v1-init-processed').each(function () {
        var thisFormatter = $(this);
        var hotspots = thisFormatter.parents('.hotspots');

        thisFormatter.find('.marker').on('click', function() {
          hotspots.find('.marker').not($(this)).removeClass('open');
          hotspots.find('.module-spp-detail').fadeTo(750, 0, function () {
            $(this).hide();
          });
          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
          } else {
            $(this).addClass('open');
          }
        });
      });
    }
  };
})(jQuery);
